export default __webpack_public_path__ + "static/media/logo02.ce7f8ffb.svg";